import tealium from '../../tealium';
import { registerAnalyticsEventHandler } from '../registry';
import { IDataLayer } from '../../tealium/data_layer';

// TODO: triggered from drupal brand-specific analytics.js
const defaultData: IDataLayer = {
  event_category: 'facets',
  event_name: 'facets_filter'
};

function trackCategoryToggle(_: string, eventData: IDataLayer = {}) {
  const payload = eventData.payload;
  const data = {
    event_action: payload.status,
    event_label: 'click',
    facet_action: payload.status,
    facet_name: payload.category
  };

  tealium.evtLink({ ...defaultData, ...eventData, ...data });
}

function trackFilterComplete(_: string, eventData: IDataLayer = {}) {
  const dataLayer = tealium.dataLayer?.data || {};
  const payload = eventData.payload;

  if (payload.action === 'clear_all') {
    const data = {
      event_action: payload.action,
      event_label: payload.action + '_' + dataLayer?.page_template?.toLowerCase()
    };

    tealium.evtLink({ ...defaultData, ...eventData, ...data });
  } else {
    let attraqtData = {};

    const action = payload.selected === 'true' ? 'clear' : 'select';

    const data = {
      event_action: action,
      event_label: payload.category + ' | ' + payload.filter_name,
      facet_action: action,
      facet_name: payload.category,
      facet_value: payload.filter_name
    };

    // When a user selects a filter, add additional attraqt vendor data
    if (action === 'select') {
      attraqtData = {
        attraqt_facet_id: payload.category_id,
        attraqt_facet_name: payload.filter_name,
        attraqt_responseId: dataLayer.attraqt_responseId,
        vendor: dataLayer.vendor
      };

      tealium.dataLayer.update({
        attraqt_facet_id: payload.category_id,
        attraqt_facet_name: payload.filter_name
      });
    }

    tealium.evtLink({ ...defaultData, ...eventData, ...data, ...attraqtData });
  }
}

registerAnalyticsEventHandler('filterComplete', trackFilterComplete);
registerAnalyticsEventHandler('categoryToggle', trackCategoryToggle);
